// Libellés des types de notification, partagés par la liste et le formulaire
export const NOTIFICATION_TYPES = {
  simple: 'Sans lien',
  post: 'Post',
  structured_product: 'Produit structuré',
  stock: 'Action',
  signal_provider: 'Signal providers',
}
